/* eslint-disable */
// @ts-nocheck
import * as Types from '../schema/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type ChecksEmailExistsQueryVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;


export type ChecksEmailExistsQuery = { __typename?: 'Query', checks: { __typename?: 'AppChecksType', emailExists: boolean } };

export type ChecksCountUserQrsForDeletionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ChecksCountUserQrsForDeletionQuery = { __typename?: 'Query', checks: { __typename?: 'AppChecksType', countUserQrsForDeletion: number } };

export type ChecksCountUserQrsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ChecksCountUserQrsQuery = { __typename?: 'Query', checks: { __typename?: 'AppChecksType', countUserQrs: number } };


export const ChecksEmailExistsDocument = gql`
    query ChecksEmailExists($email: String!) {
  checks {
    emailExists(email: $email)
  }
}
    `;

/**
 * __useChecksEmailExistsQuery__
 *
 * To run a query within a React component, call `useChecksEmailExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChecksEmailExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChecksEmailExistsQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useChecksEmailExistsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChecksEmailExistsQuery, ChecksEmailExistsQueryVariables> & ({ variables: ChecksEmailExistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChecksEmailExistsQuery, ChecksEmailExistsQueryVariables>(ChecksEmailExistsDocument, options);
      }
export function useChecksEmailExistsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChecksEmailExistsQuery, ChecksEmailExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChecksEmailExistsQuery, ChecksEmailExistsQueryVariables>(ChecksEmailExistsDocument, options);
        }
// @ts-ignore
export function useChecksEmailExistsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChecksEmailExistsQuery, ChecksEmailExistsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChecksEmailExistsQuery, ChecksEmailExistsQueryVariables>;
export function useChecksEmailExistsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChecksEmailExistsQuery, ChecksEmailExistsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChecksEmailExistsQuery | undefined, ChecksEmailExistsQueryVariables>;
export function useChecksEmailExistsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChecksEmailExistsQuery, ChecksEmailExistsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChecksEmailExistsQuery, ChecksEmailExistsQueryVariables>(ChecksEmailExistsDocument, options);
        }
export type ChecksEmailExistsQueryHookResult = ReturnType<typeof useChecksEmailExistsQuery>;
export type ChecksEmailExistsLazyQueryHookResult = ReturnType<typeof useChecksEmailExistsLazyQuery>;
export type ChecksEmailExistsSuspenseQueryHookResult = ReturnType<typeof useChecksEmailExistsSuspenseQuery>;
export type ChecksEmailExistsQueryResult = ApolloReactCommon.QueryResult<ChecksEmailExistsQuery, ChecksEmailExistsQueryVariables>;
export const ChecksCountUserQrsForDeletionDocument = gql`
    query ChecksCountUserQrsForDeletion {
  checks {
    countUserQrsForDeletion
  }
}
    `;

/**
 * __useChecksCountUserQrsForDeletionQuery__
 *
 * To run a query within a React component, call `useChecksCountUserQrsForDeletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useChecksCountUserQrsForDeletionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChecksCountUserQrsForDeletionQuery({
 *   variables: {
 *   },
 * });
 */
export function useChecksCountUserQrsForDeletionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ChecksCountUserQrsForDeletionQuery, ChecksCountUserQrsForDeletionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChecksCountUserQrsForDeletionQuery, ChecksCountUserQrsForDeletionQueryVariables>(ChecksCountUserQrsForDeletionDocument, options);
      }
export function useChecksCountUserQrsForDeletionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChecksCountUserQrsForDeletionQuery, ChecksCountUserQrsForDeletionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChecksCountUserQrsForDeletionQuery, ChecksCountUserQrsForDeletionQueryVariables>(ChecksCountUserQrsForDeletionDocument, options);
        }
// @ts-ignore
export function useChecksCountUserQrsForDeletionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChecksCountUserQrsForDeletionQuery, ChecksCountUserQrsForDeletionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChecksCountUserQrsForDeletionQuery, ChecksCountUserQrsForDeletionQueryVariables>;
export function useChecksCountUserQrsForDeletionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChecksCountUserQrsForDeletionQuery, ChecksCountUserQrsForDeletionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChecksCountUserQrsForDeletionQuery | undefined, ChecksCountUserQrsForDeletionQueryVariables>;
export function useChecksCountUserQrsForDeletionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChecksCountUserQrsForDeletionQuery, ChecksCountUserQrsForDeletionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChecksCountUserQrsForDeletionQuery, ChecksCountUserQrsForDeletionQueryVariables>(ChecksCountUserQrsForDeletionDocument, options);
        }
export type ChecksCountUserQrsForDeletionQueryHookResult = ReturnType<typeof useChecksCountUserQrsForDeletionQuery>;
export type ChecksCountUserQrsForDeletionLazyQueryHookResult = ReturnType<typeof useChecksCountUserQrsForDeletionLazyQuery>;
export type ChecksCountUserQrsForDeletionSuspenseQueryHookResult = ReturnType<typeof useChecksCountUserQrsForDeletionSuspenseQuery>;
export type ChecksCountUserQrsForDeletionQueryResult = ApolloReactCommon.QueryResult<ChecksCountUserQrsForDeletionQuery, ChecksCountUserQrsForDeletionQueryVariables>;
export const ChecksCountUserQrsDocument = gql`
    query ChecksCountUserQrs {
  checks {
    countUserQrs
  }
}
    `;

/**
 * __useChecksCountUserQrsQuery__
 *
 * To run a query within a React component, call `useChecksCountUserQrsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChecksCountUserQrsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChecksCountUserQrsQuery({
 *   variables: {
 *   },
 * });
 */
export function useChecksCountUserQrsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ChecksCountUserQrsQuery, ChecksCountUserQrsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChecksCountUserQrsQuery, ChecksCountUserQrsQueryVariables>(ChecksCountUserQrsDocument, options);
      }
export function useChecksCountUserQrsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChecksCountUserQrsQuery, ChecksCountUserQrsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChecksCountUserQrsQuery, ChecksCountUserQrsQueryVariables>(ChecksCountUserQrsDocument, options);
        }
// @ts-ignore
export function useChecksCountUserQrsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChecksCountUserQrsQuery, ChecksCountUserQrsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChecksCountUserQrsQuery, ChecksCountUserQrsQueryVariables>;
export function useChecksCountUserQrsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChecksCountUserQrsQuery, ChecksCountUserQrsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChecksCountUserQrsQuery | undefined, ChecksCountUserQrsQueryVariables>;
export function useChecksCountUserQrsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChecksCountUserQrsQuery, ChecksCountUserQrsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChecksCountUserQrsQuery, ChecksCountUserQrsQueryVariables>(ChecksCountUserQrsDocument, options);
        }
export type ChecksCountUserQrsQueryHookResult = ReturnType<typeof useChecksCountUserQrsQuery>;
export type ChecksCountUserQrsLazyQueryHookResult = ReturnType<typeof useChecksCountUserQrsLazyQuery>;
export type ChecksCountUserQrsSuspenseQueryHookResult = ReturnType<typeof useChecksCountUserQrsSuspenseQuery>;
export type ChecksCountUserQrsQueryResult = ApolloReactCommon.QueryResult<ChecksCountUserQrsQuery, ChecksCountUserQrsQueryVariables>;